module.exports = __webpack_public_path__ + "img/cplug.1564ab8f.png";